import React from 'react';
import '../styles/Home.css';
import img from '../assets/VinitaProfile.jpeg'
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { TypeAnimation } from "react-type-animation";
import resume from '../assets/resume.pdf'
function Home() {
  return (
    <div className="home-container">
      <div className="left-side">
        <div className="circle"><a href="https://www.linkedin.com/in/vinita-israni-0b704a219/"><FaLinkedin /></a></div>
        <div className="circle"><a href="https://github.com/VinitaIsrani74"><FaGithub /></a></div>
        <div className="line"></div>
      </div>
      <div className="right-side">
        <div className="heading">
        <div className="image">
        



        <div class="image-container">
  <img src={img} alt="Yourimage" />
</div>




        </div>
          <h1>VINITA ISRANI</h1>
          <h2>
          <TypeAnimation
            sequence={[

              "A MERN STACK DEVELOPER",
              1000, 
              "A EXPERIENCED  FULL STACK DEVELOPER",
              1000,
              "A WEB DEVELOPER",
              1000,
              "MCA Graduate with a Passion for Coding and Development",
              1000,
              "MCA Graduate with a Passion for Coding and Development",
              1000,
            ]}
            wrapper="span"
            speed={20}
          
            repeat={Infinity}
          />
          </h2>
       </div>
        <div className="text">
         <div>Passionate about coding and problem-solving, my background as a full stack developer helps me create dynamic and responsive websites.</div>
          <div>With an MCA in Computer Programming and real-world experience from two internships, I excel in developing seamless and efficient web applications</div>
        </div>
       <div className="buttons">
       <a href={resume} download='resume'><button className='button'>Download Resume</button></a> 
       <a href="Mailto: isranivinita74@gmail.com"><button className='button'>Mail</button></a>
       </div>
      </div>
    </div>
  );
}

export default Home;